import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";
import "@fontsource/chivo";
import axios from "axios";

const AbbonamentoSummaryPage = () => {
  const location = useLocation();
  const selectedItem = location.state?.abbonamento;

  const [nome, setNome] = useState("");
  const [cognome, setCognome] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [consent, setConsent] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

const handlePayment = async () => {
  setErrorMessage(""); // Reset prima di ogni submit

  if (!nome || !cognome || !email.includes("@") || phone.length < 6) {
    setErrorMessage("Compila tutti i campi obbligatori correttamente.");
    return;
  }
  if (!consent) {
    setErrorMessage("Devi autorizzare il trattamento dei dati personali.");
    return;
  }

  try {
    console.log("👉 Dati per verifica abbonamento:", {
      nome: nome.trim(),
      cognome: cognome.trim(),
      email: email.trim(),
    });

    const verifyRes = await axios.post("https://api.lidodavittorio.it/api/verify-abbonamento", {
      nome: nome.trim(),
      cognome: cognome.trim(),
      email: email.trim(),
    });

    console.log("✅ Risposta verifica abbonamento:", verifyRes.data);

    if (verifyRes.data.exists) {
      setErrorMessage("Questa email è già stata utilizzata per un abbonamento attivo questo mese. Verifica i dati o contattaci.");
      return;
    }

    console.log("👉 Creazione sessione Stripe con dati:", {
      abbonamento: selectedItem,
      user: {
        nome: nome.trim(),
        cognome: cognome.trim(),
        email: email.trim(),
        phone: phone.trim(),
      },
    });

    const res = await axios.post(
      "https://api.lidodavittorio.it/api/create-checkout-session-abbonamento",
      {
        abbonamento: selectedItem,
        user: {
          nome: nome.trim(),
          cognome: cognome.trim(),
          email: email.trim(),
          phone: phone.trim(),
        },
      }
    );

    console.log("✅ Sessione Stripe creata:", res.data);

    const sessionId = res.data.sessionId;

    localStorage.setItem(
      "latestAbbonamento",
      JSON.stringify({
        selectedItem,
        nome: nome.trim(),
        cognome: cognome.trim(),
        email: email.trim(),
        phone: phone.trim(),
        session_id: sessionId,
      })
    );

    console.log("🚀 Redirect verso Stripe:", res.data.url);
    window.location.href = res.data.url;

  } catch (error) {
    console.error("❌ Errore handlePayment:", error);
    setErrorMessage("Errore durante il pagamento.");
  }
};





  if (!selectedItem) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-red-600 font-[chivo] text-lg">⚠️ Nessun abbonamento selezionato.</p>
      </div>
    );
  }

  return (
    <div className="bg-white text-black min-h-screen flex flex-col">
      <NavbarWhite />
      <div className="pt-32 px-4 sm:px-6 text-center flex-1 max-w-2xl mx-auto">
        <h1 className="text-4xl font-bold text-[#009FB7] mb-6 font-[chivo]">Riepilogo Abbonamento</h1>

        <div className="mb-10">
          <p className="text-lg font-semibold">{selectedItem.titolo}</p>
          <p className="text-xl text-[#009FB7] font-bold mt-2">€{selectedItem.prezzo}</p>
        </div>

        <div className="space-y-4 text-left max-w-md mx-auto mb-6">
          <input
            type="text"
            placeholder="Nome"
            className="border border-gray-300 rounded px-4 py-2 w-full font-[chivo]"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Cognome"
            className="border border-gray-300 rounded px-4 py-2 w-full font-[chivo]"
            value={cognome}
            onChange={(e) => setCognome(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Email"
            className="border border-gray-300 rounded px-4 py-2 w-full font-[chivo]"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="tel"
            placeholder="Numero di telefono"
            className="border border-gray-300 rounded px-4 py-2 w-full font-[chivo]"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
          <div className="text-sm flex items-start gap-2">
            <input
              type="checkbox"
              checked={consent}
              onChange={(e) => setConsent(e.target.checked)}
            />
            <label>
              Autorizzo il trattamento dei miei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR).
            </label>
          </div>
        </div>

        {errorMessage && (
  <div className="mb-4 text-red-600 text-center font-semibold">
    {errorMessage}
  </div>
)}


        <button
          onClick={handlePayment}
          className="bg-[#009FB7] text-white text-lg px-8 py-3 rounded-md hover:bg-[#007d99] transition font-[chivo]"
        >
          Procedi al pagamento –{" "}
          <span className="font-bold text-yellow-300">€{selectedItem.prezzo}</span>
        </button>
      </div>

      <Footer />
    </div>
  );
};

export default AbbonamentoSummaryPage;
